import { InjectionToken } from '@angular/core';

export const NAVIGATOR = new InjectionToken<string>('NAVIGATOR');
